// ============================================================================
// STEP KEYS - Constants for step component keys
// ============================================================================

/**
 * Type-safe keys for step components.
 * Use these constants instead of hardcoded strings in flow configurations.
 */
export const STEP_KEYS = {
  // Shared steps
  SHARED_SPORT: 'shared-sport',
  SHARED_BASIC_INFO: 'shared-basic-info',
  SHARED_PRICING: 'shared-pricing',
  SHARED_CLUB_SELECTION: 'shared-club-selection',
  SHARED_SCHEDULE_SELECTION: 'shared-schedule-selection',
  SHARED_TOURNAMENT_CONFIG: 'shared-tournament-config',
  SHARED_CLUB_SCHEDULES: 'shared-club-schedules',
  SHARED_SUMMARY: 'shared-summary',
  
  // Padel-specific steps
  PADEL_TEAM_CONFIG: 'padel-team-config',
  PADEL_FIXTURE_CONFIG: 'padel-fixture-config',
  PADEL_SCHEDULE: 'padel-schedule',
  
  // Tennis-specific steps
  TENNIS_TEAM_CONFIG: 'tennis-team-config',
  TENNIS_FIXTURE_CONFIG: 'tennis-fixture-config',
  TENNIS_SCHEDULE: 'tennis-schedule',
  
  // Squash-specific steps
  SQUASH_TEAM_CONFIG: 'squash-team-config',
  SQUASH_FIXTURE_CONFIG: 'squash-fixture-config',
  SQUASH_SCHEDULE: 'squash-schedule',
} as const;

export type StepKey = typeof STEP_KEYS[keyof typeof STEP_KEYS];
